import { Trans } from '@lingui/macro';

export const CalculationFrozenText = (): JSX.Element => {
    return <Trans>Calculation approved and frozen. Editing disabled.</Trans>;
};

export const CalculationFetchingText = (): JSX.Element => {
    return <Trans>Calculation is updating.</Trans>;
};
